import styles from './AISection.module.css';

const CARDS = [
  {
    badge: 'Flagship',
    feat: true,
    title: 'NetSuite AI Enablement & Training',
    desc: "I train your team to get real value from NetSuite AI — Text Enhance, the SuiteAnalytics Assistant, Bill Capture, and the NetSuite AI Connector (MCP) — so your people level up, not just your software.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M3 8l9-4 9 4-9 4-9-4z" />
        <path d="M21 8v5M7 10.5V15c0 1.3 2.2 2.5 5 2.5s5-1.2 5-2.5v-4.5" />
      </svg>
    ),
  },
  {
    badge: 'New',
    feat: true,
    title: 'AI-Powered Performance Audit',
    desc: 'An AI-assisted deep-dive into your NetSuite account — usage, customizations, scripts, and process — surfacing exactly where to optimize, simplify, and cut cost.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M3 12a9 9 0 1 1 9 9" />
        <path d="M3 21l3.5-3.5M12 12l4-2" />
        <circle cx="12" cy="12" r="1.5" />
      </svg>
    ),
  },
  {
    title: 'Predictive Forecasting',
    desc: 'AI-powered demand planning and financial forecasting that learns from your historical data and market signals.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M3 17l5-5 4 3 7-8" />
        <path d="M16 4h4v4" />
      </svg>
    ),
  },
  {
    title: 'Intelligent Automation',
    desc: 'Smart workflows that adapt to exceptions, route approvals intelligently, and reduce manual intervention.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
        <circle cx="12" cy="12" r="4" />
      </svg>
    ),
  },
  {
    title: 'Natural Language Queries',
    desc: 'Ask questions about your data in plain English. Get instant insights without building reports.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    title: 'Transparent AI',
    desc: 'Unlike black-box solutions, the AI shows its work. Understand why recommendations are made.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
  },
];

export default function AISection() {
  return (
    <section className={`section ${styles.aiSection}`} id="ai">
      <div className="wrap">
        <div className={styles.aiHead}>
          <div className="reveal">
            <span className="eyebrow indigo">Practical AI</span>
            <h2 className="section-title" style={{ marginTop: 16 }}>
              NetSuite + AI
            </h2>
            <p className="section-lead">
              AI is already inside NetSuite — most teams just aren't using it yet. I help you put it to
              work: training your team on NetSuite AI, running an AI-powered performance audit, and
              building transparent, explainable AI — including NetSuite MCP integrations that connect
              your data to modern AI agents.
            </p>
          </div>
          <div className={`${styles.aiNote} reveal`}>
            <svg className={styles.lock} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
              <rect x="4" y="10" width="16" height="11" rx="2" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" />
            </svg>
            <span>Powered by enterprise-grade AI · Your data stays in your environment.</span>
          </div>
        </div>

        <div className={styles.aiGrid}>
          {CARDS.map((c) => (
            <div className={`${styles.aiCard} ${c.feat ? styles.feat : ''} reveal`} key={c.title}>
              {c.badge && <span className="ai-badge">{c.badge}</span>}
              <div className={styles.ic}>{c.icon}</div>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
        <div className={`${styles.aiCtaRow} reveal`}>
          <a
            href="#contact"
            className="btn btn-primary"
            style={{ background: 'var(--indigo)', boxShadow: '0 18px 40px -16px rgba(79,70,229,.5)' }}
          >
            Explore AI Enablement &amp; Audits
          </a>
        </div>
      </div>
    </section>
  );
}
